import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { LANGUAGE } from "services/general";

/**
 * Named "Amer Help" button — platform support for the tenant (Amer Help
 * Center). Sits on its own between the icon clusters and the language switch,
 * as a labelled pill so it reads as a distinct entry point (top-bar design).
 */
const AmerHelpButton = ({ isDark, count = 0 }) => {
  const { t } = useTranslation();

  const toneClass = isDark
    ? "border-primary/50 bg-primary/10 text-primary hover:bg-primary/20"
    : "border-primary/30 bg-surface text-primary hover:bg-primary-bg-soft";

  return (
    <Link
      to={`/${LANGUAGE}/amer-support`}
      title={t("amerSupport.title")}
      className={`hidden xl:flex items-center gap-2 h-10 px-3 rounded-full border text-xs font-bold whitespace-nowrap transition-colors shrink-0 ${toneClass}`}
    >
      <FontAwesomeIcon icon={faHeadset} className="text-[16px]" />
      <span>{t("amerSupport.title")}</span>
      {count > 0 && (
        <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-danger text-surface text-[10px] font-bold flex items-center justify-center leading-none">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
};

export default AmerHelpButton;
